// @ts-nocheck
import { CheckCircle } from 'lucide-react';

/** Toast when the user selects a cap table file that is already loaded. */
export function formatSameCapTableFileMessage(fileName) {
  return `Cap table already imported from "${fileName}". Choose a different file to replace it, or edit shareholders below.`;
}

/** Toast / banner copy after a successful cap table import. */
export function formatImportSuccessMessage(shareholderCount, fileName, dqiMatchCount = 0) {
  const n = shareholderCount;
  const label = n === 1 ? 'shareholder' : 'shareholders';
  let message = `Imported ${n} ${label} from ${fileName}.`;
  if (dqiMatchCount > 0) {
    message += ` ${dqiMatchCount} auto-matched as DQI.`;
  }
  return message;
}

/** Green "Imported N shareholders from <file>" banner reused by the review step. */
export const ImportSummaryBanner = ({ uploadedFileName, shareholderCount, dqiMatchCount }) => {
  if (!uploadedFileName) return null;
  return (
    <div className="bg-emerald-50/60 border border-emerald-100 rounded-lg px-4 py-2 text-xs text-emerald-700 flex items-center space-x-2">
      <CheckCircle size={13} className="flex-shrink-0" />
      <span>{formatImportSuccessMessage(shareholderCount, uploadedFileName, dqiMatchCount)}</span>
    </div>
  );
};
